import type { TSuggestionBoxSend } from '@conversed/rest/src/contracts/suggestion-box/suggestion-box.schema';
import { useCallback } from 'react';
import { client } from '../../api/rest/client';
import { Actions } from '../../constants/actionTypes';
import {
  toastErrorTranslated,
  toastSuccessTranslated,
} from '../../helpers/toast';
import { useMainDispatch } from '../useMainDispatch';

export const useSuggestionBoxActions = () => {
  const dispatch = useMainDispatch();

  const sendSuggestionBoxEmail = useCallback(
    async (body: TSuggestionBoxSend) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.suggestionBox.sendSuggestionBoxEmail({ body });
        toastSuccessTranslated('suggestion-box.modal.success');
      } catch (error: any) {
        console.error('Error sending suggestion box email:', error);
        toastErrorTranslated('suggestion-box.modal.error');
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }

      return true;
    },
    [dispatch],
  );

  return { sendSuggestionBoxEmail };
};
